import { C, T, H } from '@homeschooling/sdk'

import m from 'moment'
//import mt from 'moment-timezone'
import * as React from 'react'
import * as _ from 'lodash'

import Persistance from "../Persistence";
import { InputField } from './InputField'

import { Exit } from '../../Components/Icons'

import { InputSwitch } from 'primereact/inputswitch'
//import { HorizontalLine } from '../Common/HorizonalLine'
import SDKFactory from '../../Components/SDKFactory'

import { DatePicker } from '../Common'

interface Form {
    [key: string]: string
}

export interface Props {
    children?: React.ReactNode
    inPlaceUpdate: (x: T.ScheduleDay[]) => void
    closeForm: () => void
    form: Form
    errors: { [key: string]: string }
    startDate: string
    endDate: string
}

export interface State {
    expandExpenses: boolean
    expandNotes: boolean
    form: Form
    students: T.Student[]
    errors: { [key: string]: string }
    submitted: boolean
}

Persistance.setValues()

export class AddScheduleForm extends React.Component<Props, any> {
    private sdk = SDKFactory.getScheduleSDK()

    public constructor(props: Props) {
        super(props)

        const start = m()
        const remainder = 15 - (start.minute() % 15);

        const startTime = m(start)
            .add(remainder, "minutes")
            .format("H:mm");

        const endTime = m(start)
            .add(remainder, "minutes")
            .add(1, 'hour')
            .format("H:mm");

        let form = this.props.form.startTime ? this.props.form : {
            'startDate': m().format(),
            'endDate': m().add(1, 'month').format(),
            'startTime': startTime,
            'endTime': endTime,
            'tz': Persistance.getTz()
        }

        this.state = {
            expandExpenses: false,
            expandNotes: false,
            form: form,
            students: Persistance.getStudents(),
            submitted: false,
            errors: {}
        }

    }

    public addEvent = () => {

        this.setState({submitted: true, errors: {}})

        let errors = this.verifyAddForm()

        if (Object.keys(errors).length !== 0) {
            this.setState({ errors: errors, submitted: false })
            return
        }

        let formData = this.state.form
        this.prepEvent(formData)

    }

    public verifyAddForm = () => {

        const { form } = this.state
        let errors: any = {}

        if (!form.name) errors['name'] = 'Name is required'
        if (!form.subject) errors['subject'] = 'Select a subject'
        if (!form.course) errors['course'] = 'Select a course'
        if (!form.student) errors['student'] = 'Select a student'
        if (!form.repeating) errors['repeating'] = 'Select a repeating option'
        if (!m(form.startDate).isValid()) errors['startDate'] = 'Valid start date is required'
        if (!m(form.endDate).isValid()) errors['endDate'] = 'Valid end date is required'
        if (!form.tz) errors['tz'] = 'Select a timezone'

        if (!form.allDay) {

            let start = m(form.startTime, 'HH:mm', true)
            let end = m(form.endTime, 'HH:mm', true)
            if (!start.isValid()) errors['startTime'] = 'Start time is required'
            if (!end.isValid()) errors['endTime'] = 'End Time is required'
            if (end.isBefore(start, 'minutes')) errors['endDate'] = 'End date can not be before start date'
        }

        return errors
    }

    public prepEvent = async (event?: Form) => {
        let { form } = this.state

        form = event ? event : form

        let days = H.buildBinaryFromDays(
            form['sun'] === 'true',
            form['mon'] === 'true',
            form['tues'] === 'true',
            form['wed'] === 'true',
            form['thurs'] === 'true',
            form['fri'] === 'true',
            form['sat'] === 'true')

        let end_date = form['indefinite'] === 'true' ? '9999-12-30' : m(form['endDate']).format('YYYY-MM-DD')

        let student = { id: form['student'] } as T.Student

        let data: T.Schedule = {
            name: form['name'],
            days_of_week: days,
            students: [student],
            subject: form['subject'],
            course: form['course'],
            description: form['description'],
            location: form['location'],
            provider: form['provider'],
            all_day: form['allDay'] === 'true',
            start_date: m(form['startDate']).format('YYYY-MM-DD'),
            end_date: end_date,
            starts_at: form['startTime'],
            ends_at: form['endTime'],
            repeating: form['repeating'],
            add_to_transcript: form['transcript'] === 'true',
            expenses: [],
            notes: [],
            tz: form['tz']
        }

        await this.addScheduleEvent(data)
    }


    public addScheduleEvent = async (data: T.Schedule) => {
        try {

            let start_date = this.props.startDate
            let end_date = this.props.endDate

            const res = await this.sdk.createSchedule(data, start_date, end_date)

            let sche = res.data
            const hasError: boolean = _.get(sche, 'errors', false) as boolean

            if (!hasError && res.status === 'success') {
                let data = sche as T.ScheduleDay[]
                this.setState({submitted: false})
                this.props.inPlaceUpdate(data)
                this.props.closeForm()
            }
        } catch (reason) {
            console.log('Error saving schedule event', reason)
        }
    }

    public toggleAllDay = () => {

        let allDay = 'false'

        if (!this.state.form.allDay || this.state.form.allDay === 'false') {
            allDay = 'true'
        }

        const { form } = this.state
        form['allDay'] = allDay
        this.setState({ form })
    }

    public toggleIndefinite = () => {

        let indefinite = 'false'

        if (!this.state.form.indefinite || this.state.form.indefinite === 'false') {
            indefinite = 'true'
        }

        const { form } = this.state
        form['indefinite'] = indefinite
        this.setState({ form })
    }

    public inputChanged = (key: string) =>
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const { form, errors } = this.state
            form[key] = e.target.value
            delete errors[key]

            this.setState({
                form,
            })
        }

    public setRepeatingOptions = (key: string) =>     
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const { form, errors } = this.state
            form[key] = e.target.value
            delete errors[key]

            if(e.target.value === '1TIME') {
                form['endDate'] = form['startDate']
                let day = m(form['startDate']).day()
                switch(day) {
                    case 0:
                       form['sun'] = 'true'
                       break;
                    case 1:   
                        form['mon'] = 'true'
                        break;
                    case 2:
                        form['tues'] = 'true'
                        break;
                    case 3:
                        form['wed'] = 'true'
                        break;
                    case 4:
                        form['thurs'] = 'true'
                        break;
                    case 5:
                        form['fri'] = 'true'
                        break;
                    case 6:
                        form['sat'] = 'true' 
                    break;
                }
            }

            this.setState({
                form,
            })
        }

    public resetDays = () => {
        const { form } = this.state
        form['sun'] = 'false'
        form['mon'] = 'false'
        form['tues'] = 'false'
        form['wed'] = 'false'
        form['thurs'] = 'false'
        form['fri'] = 'false'
        form['sat'] = 'false'
        this.setState({form})
    }    

    public setDatePickerFormInfo = (key: string, e: any) => {
        const { form } = this.state
        form[key] = m(e).format()

        if(key === 'startDate' && form['repeating'] === '1TIME') {
            form['endDate'] = m(e).format()
            this.resetDays()
            let day = m(e).day()
                switch(day) {
                    case 0:
                       form['sun'] = 'true'
                       break;
                    case 1:   
                        form['mon'] = 'true'
                        break;
                    case 2:
                        form['tues'] = 'true'
                        break;
                    case 3:
                        form['wed'] = 'true'
                        break;
                    case 4:
                        form['thurs'] = 'true'
                        break;
                    case 5:
                        form['fri'] = 'true'
                        break;
                    case 6:
                        form['sat'] = 'true' 
                    break;
                }
        }

        this.setState({
            form,
        })

    }

    public toggleAddToTranscripts = () => {
        let transcripts = 'false'

        if (!this.state.form.transcripts || this.state.form.transcripts === 'false') {
            transcripts = 'true'
        }

        const { form } = this.state
        form['transcripts'] = transcripts
        this.setState({ form })
    }

    public toggleScheduleDay = (key: string) => {
        const { form } = this.state

        if (form[key] === 'true') {
            form[key] = 'false'
        } else {
            form[key] = 'true'
        }

        this.setState({
            form,
        })
    }

    public getStudentOptions = () => {
        let options: any = []

        for (let s of this.state.students) {
            options[s.id] = s.name
        }

        return options
    }

    public getRepeatsOption = () => {
        let repeats = C.repeating

        let options: any = []

        _.forOwn(repeats, (value, key) => {
            options[key] = value.label
        })

        return options
    }

    public getSubjectOption = () => {
        let subjects = C.subject

        let options: any = []

        _.forOwn(subjects, (value, key) => {
            options[key] = value.label
        })

        return options
    }

    public getCourseOption = () => {

        let options: any = []

        if (this.state.form.subject) {
            let courses = C.getSubjectConstants(this.state.form.subject)

            _.forOwn(courses, (value, key) => {
                options[key] = value.label
            })
        }

        return options
    }

    public getStartTImeSection = () => {


        const { form } = this.state

        return (
            <div className='w-full my-2'>
                <div className='w-full grid grid-col gap-2'>
                    <div className='w-full'>
                        <div className='w-full my-2 flex flex-col relative'>
                            <div className='w-1/2'>
                                Start Date*
                            </div>
                            <div className='w-full'>
                                <DatePicker
                                    date={m(this.state.form.startDate).format()} cb={(e) => this.setDatePickerFormInfo('startDate', e)} />
                            </div>
                        </div>
                    </div>
                    { this.state.form.allDay !== 'true' &&
                    <div className='w-full flex flex-col'>
                        <div className='w-full grid grid-cols-2 gap-2'>
                        <div>
                                    <InputField
                                        borderColor='default'
                                        cb={this.inputChanged('startTime')}
                                        disabled={false}
                                        errors={this.state.errors?.startTime}
                                        helperErrors={true}
                                        label={'Start Time'}
                                        labelColor='default'
                                        id='startTime'
                                        required={true}
                                        options={C.gettimes()}
                                        type='select'
                                        value={form.startTime}
                                        placeHolder='Start Time'
                                    >
                                    </InputField>
                        </div>
                        <div>
                              <InputField
                                        borderColor='default'
                                        cb={this.inputChanged('endTime')}
                                        disabled={false}
                                        errors={this.state.errors?.endTime}
                                        helperErrors={true}
                                        label={'End Time'}
                                        labelColor='default'
                                        id='endTime'
                                        required={true}
                                        options={C.gettimes()}
                                        type='select'
                                        value={form.endTime}
                                        placeHolder='End Time'
                                    >
                                    </InputField>
                            </div>
                    </div>
                    <div className="w-full flex">
                                    <dd className="text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        
                                                                            <InputField
                                                                                borderColor='default'
                                                                                cb={this.inputChanged('tz')}
                                                                                disabled={false}
                                                                                errors={this.state.errors?.tz}
                                                                                helperErrors={true}
                                                                                label={'Timezone'}
                                                                                labelColor='default'
                                                                                id='startTime'
                                                                                required={true}
                                                                                options={C.getTzOptions()}
                                                                                type='select'
                                                                                value={form.tz}
                                                                                placeHolder='Select Timezone'
                                                                            >
                                                                            </InputField>
                                            
                                    </dd>
                                </div>
                    </div>
                    }
                </div>
            </div>
        )
    }

    public repeatingSection = () => {

        return (
            <div>
                {(this.state.form.repeating && this.state.form.repeating !== '1TIME') && 
                <div className='w-full my-2 flex flex-col'>
                    <div className='flex flex-row justify-end safe'>
                    <div className='flex pr-2'>
                        Repeat Indefinitely
                    </div>
                    <div className='flex'>
                        <InputSwitch checked={this.state.form.indefinite === 'true'} onChange={(e) => this.toggleIndefinite()} />
                    </div>
                    </div>
                    {this.state.form.indefinite !== 'true' &&
                    <div className='w-full flex flex-row'>
                        <div className='w-full my-2 flex flex-col relative'>
                            <div className='w-full'>
                                Repeat Until
                            </div>
                            <div className='w-full'>
                                <DatePicker
                                    date={m(this.state.form.endDate).format()} cb={(e) => this.setDatePickerFormInfo('endDate', e)} />
                            </div>
                        </div>
                    </div>}
                </div>}
                <div className='w-full'>Pick days of week event takes place.</div>
                <div className='w-full my-4 flex flex-col items-center'>
                    <div className="inline-flex rounded-md shadow-sm" role="group">
                        <button type="button" onClick={(e) => this.toggleScheduleDay('sun')}
                            className={(this.state.form['sun'] === 'true' ? 'selected-btn' : 'select-btn') + ' rounded-s-lg'}>
                            Sun
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('mon')}
                            className={(this.state.form['mon'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Mon
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('tues')}
                            className={(this.state.form['tues'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Tues
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('wed')}
                            className={(this.state.form['wed'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Wed
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('thurs')}
                            className={(this.state.form['thurs'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Thurs
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('fri')}
                            className={(this.state.form['fri'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Fri
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('sat')}
                            className={(this.state.form['sat'] === 'true' ? 'selected-btn' : 'select-btn') + ' rounded-e-lg'}>
                            Sat
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    public render(): React.ReactNode {

        const { form } = this.state

        return (
            <div className='w-120 flex flex-col'>
                <div className='w-full flex flew-row items-center'>
                    <h2 className='w-auto grow text-left text-l font-semibold text-gray-900'>Add New Event</h2>
                    <div onClick={() => this.props.closeForm()} className='w-auto flex-none text-right justify-items-end hover:cursor-pointer'>
                        <Exit size='small' />
                    </div>
                </div>

                <form noValidate className="space-y-4 md:space-y-6">
                    <div className='w-full flex flex-col'>
                        <div className='w-full my-2'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('name')}
                                disabled={false}
                                errors={this.state.errors?.name}
                                helperErrors={true}
                                label={'Add Event Name'}
                                labelColor='default'
                                id='event_name'
                                required={true}
                                type='heroText'
                                value={form.name}
                                placeHolder='Add Event Name'
                            >

                            </InputField>
                        </div>
                        <div className='w-full my-2'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('student')}
                                disabled={false}
                                errors={this.state.errors?.student}
                                helperErrors={true}
                                label={'Select A Student'}
                                labelColor='default'
                                id='student'
                                required={true}
                                options={this.getStudentOptions()}
                                type='select'
                                value={form.email}
                                placeHolder='Choose A Student'
                            >

                            </InputField>
                        </div>
                        <div className='w-full my-2 flex flex-row'>
                            <div className='w-1/2 flex flex-row justify-end'>
                                <div className='w-auto text-sm pr-2'>
                                    Add event to transcripts
                                </div>
                                <div className='w-auto'>
                                    <InputSwitch checked={this.state.form.transcripts === 'true'} onChange={(e) => this.toggleAddToTranscripts()} />
                                </div>
                            </div>
                            <div className='w-1/2 flex flex-row justify-end'>
                                <div className='w-auto text-sm text-right pr-4'>
                                    All Day Event
                                </div>
                                <div className='w-auto text-right'>
                                    <InputSwitch checked={this.state.form.allDay === 'true'} onChange={(e) => this.toggleAllDay()} />
                                </div>
                            </div>
                        </div>
                        {this.getStartTImeSection()}
                        <div className='w-full my-2 flex flex-row'>
                            <InputField
                                borderColor='default'
                                cb={this.setRepeatingOptions('repeating')}
                                disabled={false}
                                errors={this.state.errors?.repeating ? true : false}
                                helperErrors={true}
                                label={'Select frequency of repeating'}
                                labelColor='default'
                                id='repeating'
                                required={true}
                                options={this.getRepeatsOption()}
                                type='select'
                                value={form.email}
                            >

                            </InputField>
                        </div>

                        {this.repeatingSection()}
                        <div className='w-full grid grid-cols-2 gap-4'>
                            <div>
                                <InputField
                                    borderColor='default'
                                    cb={this.inputChanged('subject')}
                                    disabled={false}
                                    errors={this.state.errors?.subject ? true : false}
                                    helperErrors={true}
                                    label={'Subject'}
                                    labelColor='default'
                                    id='subject'
                                    required={true}
                                    options={this.getSubjectOption()}
                                    type='select'
                                    value={form.subject}
                                    placeHolder='Select A Subject'
                                >

                                </InputField>
                            </div>
                            <div>
                                <InputField
                                    borderColor='default'
                                    cb={this.inputChanged('course')}
                                    disabled={false}
                                    errors={this.state.errors?.course ? true : false}
                                    helperErrors={true}
                                    label={'Course'}
                                    labelColor='default'
                                    id='subject'
                                    required={true}
                                    options={this.getCourseOption()}
                                    type='select'
                                    value={form.course}
                                    placeHolder='Select A Course'
                                >

                                </InputField>
                            </div>
                        </div>
                        <div className='w-full my-2 flex flex-row'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('location')}
                                disabled={false}
                                errors={this.state.errors?.location ? true : false}
                                helperErrors={true}
                                label={'Location'}
                                labelColor='default'
                                id='location'
                                required={false}
                                type='text'
                                value={form.email}
                                placeHolder='Location of Event'
                            >

                            </InputField>
                        </div>
                        <div className='w-full my-2 flex flex-row'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('provider')}
                                disabled={false}
                                errors={this.state.errors?.provider ? true : false}
                                helperErrors={true}
                                label={'Provider'}
                                labelColor='default'
                                id='provider'
                                required={false}
                                type='text'
                                value={form.email}
                                placeHolder='Provider of Event'
                            >
                            </InputField>
                        </div>
                        <div className='w-full my-2 flex flex-row'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('description')}
                                disabled={false}
                                errors={this.state.errors?.description}
                                helperErrors={true}
                                label={'Event Description'}
                                labelColor='default'
                                id='description'
                                required={false}
                                type='textarea'
                                value={form.description}
                                numRows={2}
                                limit={250}
                            >

                            </InputField>
                        </div>
                        <div className='w-full flex flex-row items-center'>
                            <div className='w-auto grow text-right pr-4'>
                                {/*Add another Event*/}
                            </div>
                            <div className='w-auto flex-none justify-items-right'>
                                <button
                                    disabled={this.state.submitted}
                                    onClick={() => this.addEvent()}
                                    type="button"
                                    className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Add Event
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

}

export default AddScheduleForm